import React, { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { playWhooshDing } from "@/lib/introSound";
import "./IntroSplash.css";

const TAGLINE = "Building Connections Worldwide";

const TypedTagline = () => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (count >= TAGLINE.length) {
      return undefined;
    }
    const t = setTimeout(() => setCount((c) => c + 1), count === 0 ? 1200 : 65);
    return () => clearTimeout(t);
  }, [count]);
  return (
    <p className="eti-intro-tagline" aria-label={TAGLINE} data-testid="intro-typed-tagline">
      <span aria-hidden="true">{TAGLINE.slice(0, count)}</span>
      <span className="eti-intro-caret" aria-hidden="true" />
    </p>
  );
};

export const IntroSplash = ({ onEnter }) => {
  const [paused, setPaused] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [soundOn, setSoundOn] = useState(() => localStorage.getItem("eti_intro_sound") !== "off");

  const toggleSound = () => {
    localStorage.setItem("eti_intro_sound", soundOn ? "off" : "on");
    setSoundOn(!soundOn);
  };

  const enter = () => {
    setLeaving(true);
    setTimeout(onEnter, 600);
  };

  const enterWithSound = () => {
    if (!soundOn) {
      enter();
      return;
    }
    playWhooshDing();
    setTimeout(enter, 700);
  };

  useEffect(() => {
    if (paused) {
      return undefined;
    }
    const t = setTimeout(enter, 9000);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paused]);

  return (
    <main className={`eti-intro ${paused ? "is-paused" : ""} ${leaving ? "is-leaving" : ""}`} aria-label="Exclusive Trades Inc animated website intro" data-testid="intro-splash">
      <div className="eti-intro-art" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/intro-art.jpg)` }} role="img" aria-label="Exclusive Trades Inc logo in front of a glowing blue globe with red global connection points" />
      <div className="eti-intro-shade" />
      <div className="eti-intro-orbit" />
      <div className="eti-intro-orbit two" />
      <div className="eti-intro-sweep" />
      <TypedTagline />
      <button type="button" className="eti-intro-pause" onClick={() => setPaused((p) => !p)} data-testid="intro-pause-btn">
        {paused ? "PLAY ANIMATION" : "PAUSE ANIMATION"}
      </button>
      <button type="button" className="eti-intro-sound" onClick={toggleSound} aria-label={soundOn ? "Mute intro sound" : "Unmute intro sound"} data-testid="intro-sound-toggle">
        {soundOn ? <Volume2 size={14} /> : <VolumeX size={14} />} {soundOn ? "SOUND ON" : "SOUND OFF"}
      </button>
      <button type="button" className="eti-intro-enter" onClick={enterWithSound} disabled={leaving} data-testid="intro-enter-btn">
        ENTER SITE <span aria-hidden="true">→</span>
      </button>
      <div className="eti-intro-controls" data-testid="intro-tagline">
        <span className="eti-intro-dot" /> EXCLUSIVE TRADES INC. <span style={{ color: "#ff3544" }}>•</span> GLOBAL CONNECTION
      </div>
    </main>
  );
};
